import { initializeApp } from 'firebase/app';
import { getFirestore } from "firebase/firestore";

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyDbIhKVu9dNfAKljWThXGsFgw4S89yz-dM",
  authDomain: "twentythreesearch.firebaseapp.com",
  projectId: "twentythreesearch",
  storageBucket: "twentythreesearch.appspot.com",
  messagingSenderId: "12034429280",
  appId: "1:12034429280:web:371eb0f944fa9042090e05"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore();
